<div class="header-main" data-cy="referral-portal-header">
  <div *ngIf="this.PracticeName"
       style="font-size: 12px; position: absolute; bottom: 2px; left: 63px; color: rgba(255,255,255,0.4); margin-right: 4px; z-index: 1000;">
    <span style="font-weight: bold" data-cy="referral-portal-practice-name">{{this.PracticeName}}</span>
  </div>
  <div style="flex-basis: 200px; margin-left: 16px; padding-top: 9px; cursor: pointer;">
    <img alt="TDO Logo" src="../../../assets/Images/navbar-icons/v2/new_tdo_logo.svg" data-cy="referral-portal-logo"/>
  </div>
  <div *ngIf="this.ReferralToDoctor"
       style="font-size: 20px; margin-top: 20px; margin-left: 400px; color: var(--tdo-cement); z-index: 1000;">
    <span data-cy="referral-portal-to-doctor">Referral to {{this.ReferralToDoctor}}</span>
  </div>
  <div *ngIf="this.ReferralName"
       style="font-size: 20px; margin-left: auto; margin-right: 15px; color: var(--tdo-cement); z-index: 1000;">
    <span data-cy="referral-portal-name">{{this.ReferralName}}</span>
  </div>
</div>
<div *ngIf="isLoading" data-cy="referral-portal-loading">
  <app-tdo-progress-spinner style="position: relative; top: 400px;" data-cy="referral-portal-spinner"></app-tdo-progress-spinner>
</div>
<div *ngIf="this.authorizedUser && !isLoading" id="divLandingCont" data-cy="referral-portal-content">
  <div id="divDBInfo" data-cy="referral-portal-provider-selection">
    <div *ngIf="doctorList.length > 1" class="divDBInfoScroll">
      <mat-radio-group [(ngModel)]="this.currentProvider"
        class="radio-group" data-cy="referral-portal-provider-group">
        <mat-radio-button class="radio-button" *ngFor="let ent of doctorList, let i = index"
                          (click)="changeDr(ent, $event)"
                          [value]="ent"
                          [attr.data-cy]="'SelectedProvider-' + i">
          {{(ent.Title !== null ? ent.Title + ' ' : '' ) + ent.dataContact.FirstName + ' ' + ent.dataContact.LastName}}
        </mat-radio-button>
      </mat-radio-group>
    </div>
  </div>
  <div id="divDBdisplay" data-cy="referral-portal-display">
    <div style="display: flex; flex: 1; flex-direction: row">
      <div style="display: flex; flex-direction: column; width: 28%">
        <mat-card class="Card-style" style="height: 250px" data-cy="referral-portal-doctor-card">
          <mat-card-title-group>
            <mat-card-title class="Card-title" data-cy="referral-portal-doctor-title">Referring Doctor</mat-card-title>
          </mat-card-title-group>
          <mat-card-content>
            <div style="display: flex; flex: 1; flex-direction: column; margin: 5px;justify-content:flex-start">
              <mat-grid-list cols="1" rowHeight="50px" class="grid-list-container">
                <mat-grid-tile [colspan]="1" [rowspan]="1" class="mat-grid-tile-container">
                  <tdo-input [autocomplete]="name" name="name" placeholder="Full Name" placeholderPosition="above"
                             cypressControlIdentifier="referring-doctor-Fullname"
                             [isRequired]="true"
                             type ="text"
                             [value]="this.ReferringDoctor.FullName"
                             (inputFinished)="this.ReferringDoctor.FullName = $event" style="width: 100%" data-cy="referral-portal-doctor-fullname-input"></tdo-input>
                </mat-grid-tile>
                <mat-grid-tile [colspan]="1" [rowspan]="1" class="mat-grid-tile-container">
                  <tdo-input name="email" [autocomplete]="email" type="email" placeholder="Email Address" placeholderPosition="above"
                             cypressControlIdentifier="referring-doctor-Email"
                             style="width: 100%"
                             [isRequired]="true"
                             type ="text"
                             [value]="this.ReferringDoctor.email"
                             (inputFinished)="this.ReferringDoctor.email = $event" data-cy="referral-portal-doctor-email-input"></tdo-input>
                </mat-grid-tile>
                <mat-grid-tile [colspan]="1" [rowspan]="1" class="mat-grid-tile-container">
                  <tdo-input name="phone" [autocomplete]="phone" type="phone" widthString="100%" placeholder="Phone" [restrictTo]="'[0-9]'"
                             cypressControlIdentifier="referring-doctor-Phone"
                             [isRequired]="true" placeholderPosition="above"
                             style="width: 100%"
                             [value]="this.ReferringDoctor.phone"
                             (inputFinished)="this.ReferringDoctor.phone = $event" data-cy="referral-portal-doctor-phone-input"></tdo-input>
                </mat-grid-tile>
              </mat-grid-list>
            </div>
          </mat-card-content>
        </mat-card>
        <mat-card class="Card-style" style="height: 250px" data-cy="referral-portal-patient-card">
          <mat-card-title-group>
            <mat-card-title class="Card-title" data-cy="referral-portal-patient-title">Patient Information</mat-card-title>
          </mat-card-title-group>
          <mat-card-content>
            <div style="display: flex; flex: 1; flex-direction: column; margin: 5px;justify-content:flex-start">
              <mat-grid-list cols="2" rowHeight="50px" class="grid-list-container">
                <mat-grid-tile [colspan]="1" [rowspan]="1" class="mat-grid-tile-container">
                  <tdo-input placeholder="First Name" placeholderPosition="above"
                             cypressControlIdentifier="patient-FirstName"
                             style="width: 100%"
                             [isRequired]="true"
                             type ="text"
                             [value]="this.ReferralData.Patient_FirstName"
                             (inputFinished)="this.ReferralData.Patient_FirstName = $event" data-cy="referral-portal-patient-firstname-input"></tdo-input>
                </mat-grid-tile>
                <mat-grid-tile [colspan]="1" [rowspan]="1" class="mat-grid-tile-container">
                  <tdo-input placeholder="Last Name" placeholderPosition="above"
                             cypressControlIdentifier="patient-LastName"
                             style="width: 100%"
                             type ="text"
                             [isRequired]="true"
                             [value]="this.ReferralData.Patient_LastName"
                             (inputFinished)="this.ReferralData.Patient_LastName = $event" data-cy="referral-portal-patient-lastname-input"></tdo-input>
                </mat-grid-tile>

                <mat-grid-tile [colspan]="2" [rowspan]="2" class="mat-grid-tile-container">
                  <tdo-date-input widthString="100%" placeholder="Date Of Birth" [isRequired]="false"
                                  placeholderPosition="above"
                                  cypressControlIdentifier="patient-DOB"
                                  style="width: 100%"
                                  [valueAsDate]="getDate(this.ReferralData.Patient_DOB)"
                                  (dateChanged)="this.ReferralData.Patient_DOB = $event; this.ReferralData.Patient_DOB = $event" data-cy="referral-portal-patient-dob-input"></tdo-date-input>
                </mat-grid-tile>
                <mat-grid-tile [colspan]="1" [rowspan]="1" class="mat-grid-tile-container">
                  <tdo-input type="email" placeholder="Email" placeholderPosition="above"
                             cypressControlIdentifier="patient-Email"
                             style="width: 100%"
                             [value]="this.ReferralData.Patient_email"
                             (inputFinished)="this.ReferralData.Patient_email = $event" data-cy="referral-portal-patient-email-input"></tdo-input>
                </mat-grid-tile>
                <mat-grid-tile [colspan]="1" [rowspan]="1" class="mat-grid-tile-container">
                  <tdo-input type="phone" placeholder="Phone" placeholderPosition="above"
                             cypressControlIdentifier="patient-Phone"
                             style="width: 100%"
                             [value]="this.ReferralData.Patient_phone"
                             (inputFinished)="this.ReferralData.Patient_phone = $event" data-cy="referral-portal-patient-phone-input"></tdo-input>
                </mat-grid-tile>
              </mat-grid-list>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
      <div style="display: flex; flex-direction: column; width: 25%; height: 30%">
        <mat-card class="Card-style" style="height: 250px" data-cy="referral-portal-schedule-card">
          <mat-card-title-group>
            <mat-card-title class="Card-title" data-cy="referral-portal-schedule-title">Schedule*</mat-card-title>
          </mat-card-title-group>
          <mat-card-content class="divDBInfoScroll">
            <div *ngIf="currentProvider"
                 style="display: flex; flex: 1; flex-direction: column; margin: 5px;justify-content:flex-start">
              <mat-radio-group [(ngModel)]="this.ReferralData.ReferralScheduleItemID"
                class="radio-group" data-cy="referral-portal-schedule-group">
                <mat-radio-button class="radio-button" *ngFor="let ent of currentProvider.cfgReferralSchedule, let i = index"
                                  (click)="changeReferralSchedule(ent)"
                                  [value]="ent.ReferralScheduleItemID"
                                  [attr.data-cy]="'ReferralSchedule-' + i">
                  {{ent.ItemName}}
                </mat-radio-button>
              </mat-radio-group>
            </div>
          </mat-card-content>
        </mat-card>
        <mat-card class="Card-style" style="height: 250px" data-cy="referral-portal-insurance-card">
          <mat-card-title-group>
            <mat-card-title class="Card-title" data-cy="referral-portal-insurance-title">
              <div style="display: flex; flex: 1; flex-direction: row">
                <span>Insurance</span>
                <div style="display: flex; flex: 1; flex-direction: row;padding-left: 150px "><input
                  style="margin-right: auto" #checkBox type="checkbox" id="check" [(ngModel)]="SelfInsurance"
                  [attr.data-cy]="'SelfInsurance'"
                  (change)="SelfChecked($event)" data-cy="referral-portal-insurance-self-checkbox">
                  <span style="padding-left: 2px">Self</span></div>
              </div>
            </mat-card-title>
          </mat-card-title-group>
          <mat-card-content>
            <div style="display: flex; flex: 1; flex-direction: column; margin: 5px;justify-content:flex-start">
              <mat-grid-list cols="2" rowHeight="50px" class="grid-list-container">
                <mat-grid-tile [colspan]="1" [rowspan]="1" class="mat-grid-tile-container">
                  <tdo-input placeholder="First Name" placeholderPosition="above"
                             cypressControlIdentifier="Insurance-FirstName"
                             style="width: 100%"
                             type ="text"
                             [value]="this.ReferralData.Insurance_FirstName"
                             (inputFinished)="this.ReferralData.Insurance_FirstName = $event" data-cy="referral-portal-insurance-firstname-input"></tdo-input>
                </mat-grid-tile>

                <mat-grid-tile [colspan]="1" [rowspan]="1" class="mat-grid-tile-container">
                  <tdo-input placeholder="Last Name" placeholderPosition="above"
                             cypressControlIdentifier="Insurance-LastName"
                             style="width: 100%"
                             type ="text"
                             [value]="this.ReferralData.Insurance_LastName"
                             (inputFinished)="this.ReferralData.Insurance_LastName = $event" data-cy="referral-portal-insurance-lastname-input"></tdo-input>
                </mat-grid-tile>
                <mat-grid-tile [colspan]="2" [rowspan]="2" class="mat-grid-tile-container">
                  <tdo-date-input *ngIf="this.SelfInsurance" widthString="100%" placeholder="Date Of Birth"
                                  [isRequired]="false"
                                  cypressControlIdentifier="Insurance-DOB"
                                  placeholderPosition="above"
                                  style="width: 100%"
                                  [valueAsDate]="getDate(this.ReferralData.Patient_DOB)"
                                  (dateChanged)="this.ReferralData.Insurance_DOB = $event; this.ReferralData.Insurance_DOB = $event" data-cy="referral-portal-insurance-dob-self-input">
                  </tdo-date-input>
                  <tdo-date-input *ngIf="!this.SelfInsurance" widthString="100%" placeholder="Date Of Birth"
                                  [isRequired]="false"
                                  cypressControlIdentifier="Insurance-DOB"
                                  placeholderPosition="above"
                                  style="width: 100%"
                                  [valueAsDate]="getDate(this.ReferralData.Insurance_DOB)"
                                  (dateChanged)="this.ReferralData.Insurance_DOB = $event; this.ReferralData.Insurance_DOB = $event" data-cy="referral-portal-insurance-dob-input">
                  </tdo-date-input>
                </mat-grid-tile>
                <mat-grid-tile [colspan]="1" [rowspan]="1" class="mat-grid-tile-container">
                  <tdo-input placeholder="Insurance Company" placeholderPosition="above"
                             cypressControlIdentifier="Insurance-Company"
                             style="width: 100%"
                             type ="text"
                             [value]="this.ReferralData.Insurance_Company"
                             (inputFinished)="this.ReferralData.Insurance_Company = $event" data-cy="referral-portal-insurance-company-input"></tdo-input>
                </mat-grid-tile>
                <mat-grid-tile [colspan]="1" [rowspan]="1" class="mat-grid-tile-container">
                  <tdo-input placeholder="Insurance Number" placeholderPosition="above"
                             cypressControlIdentifier="Insurance-Number"
                             style="width: 100%"
                             type ="text"
                             [value]="this.ReferralData.Insurance_Number"
                             (inputFinished)="this.ReferralData.Insurance_Number = $event" data-cy="referral-portal-insurance-number-input"></tdo-input>
                </mat-grid-tile>
              </mat-grid-list>
              <span style="font-weight: bold" data-cy="referral-portal-insurance-card-note">Please, attach an image of the insurance card if possible.</span>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
      <div style="display: flex; flex-direction: column; width: 47%">
        <mat-card class="Card-style" style="height: 150px" data-cy="referral-portal-teeth-card">
          <mat-card-title-group>
            <mat-card-title class="Card-title" data-cy="referral-portal-teeth-title">select teeth*</mat-card-title>
          </mat-card-title-group>
          <mat-card-content class="divDBInfoScrollHorizontal">
            <div class="checkbox-list" data-cy="referral-portal-upper-teeth-list">
              <div class="checkbox-item" *ngFor="let item of ListOfUpperTeeth, let i = index">
                <div class="checkbox-style">
                  <mat-checkbox (change)="selectedUpperTeeth(item)" [attr.data-cy]="'selectedUpperTeeth-' + i" [checked]="item.checked"></mat-checkbox>
                  <div class="text" data-cy="referral-portal-upper-teeth-notation">{{ item.Notation }}</div>
                </div>
              </div>
            </div>
            <div class="checkbox-list" data-cy="referral-portal-lower-teeth-list">
              <div class="checkbox-item" *ngFor="let item of ListOfLowerTeeth, let i = index">
                <div class="checkbox-style">
                  <div class="text" data-cy="referral-portal-lower-teeth-notation">{{ item.Notation }}</div>
                  <mat-checkbox (change)="selectedLowerTeeth(item)" [attr.data-cy]="'selectedlowerTeeth-' + i" [checked]="item.checked"></mat-checkbox>
                </div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
        <mat-card class="Card-style" style="height: 97px" data-cy="referral-portal-discomfort-card">
          <mat-card-title-group>
            <mat-card-title class="Card-title" data-cy="referral-portal-discomfort-title">Discomfort Level</mat-card-title>
          </mat-card-title-group>
          <mat-card-content>
            <mat-radio-group [(ngModel)]="this.ReferralData.DiscomfortLevel"
              class="horizontal-radio-list" data-cy="referral-portal-discomfort-group">
              <mat-radio-button class="radio-button" *ngFor="let ent of DiscomfortLevelList, let i = index"
                                (click)="changeDiscomfort(ent)"
                                [value]="ent.id"
                                [attr.data-cy]="'DiscomfortLevel-' + i">
                {{ent.value}}
              </mat-radio-button>
            </mat-radio-group>
          </mat-card-content>
        </mat-card>
        <div style="display: flex; flex: 1; flex-direction: row">
          <mat-card class="Card-style" style="height: 250px; width: 50%" data-cy="referral-portal-treatment-card">
            <mat-card-title-group>
              <mat-card-title class="Card-title" data-cy="referral-portal-treatment-title">Treatment Requested*</mat-card-title>
            </mat-card-title-group>
            <mat-card-content class="divDBInfoScroll">
              <div *ngIf="currentProvider"
                   style="display: flex; flex: 1; flex-direction: column; margin: 5px;justify-content:flex-start">
                <mat-selection-list [multiple]="true" name="ReferralTreatmentList" #referralTreatmentRequestedList data-cy="referral-portal-treatment-list">
                  <mat-list-option *ngFor="let ent of currentProvider.cfgReferralTretment, let i = index"
                                   (click)="changeReferralTreatment(ent)"
                                   [attr.data-cy]="'ReferralTreatment-' + i">
                    {{ent.ItemName}}
                  </mat-list-option>
                </mat-selection-list>
              </div>
            </mat-card-content>
          </mat-card>
          <mat-card class="Card-style" style="height: 250px; width: 50%" data-cy="referral-portal-services-card">
            <mat-card-title-group>
              <mat-card-title class="Card-title" data-cy="referral-portal-services-title">Other Services</mat-card-title>
            </mat-card-title-group>
            <mat-card-content class="divDBInfoScroll">
              <div *ngIf="currentProvider"
                   style="display: flex; flex: 1; flex-direction: column; margin: 5px;justify-content:flex-start">
                <mat-selection-list [multiple]="true" #otherServicesList data-cy="referral-portal-services-list">
                  <mat-list-option *ngFor="let ent of currentProvider.cfgReferralOtherService, let i = index"
                                   (click)="changeReferralOtherService(ent)"
                                   [attr.data-cy]="'ReferralOtherService-' + i">
                    {{ent.ItemName}}
                  </mat-list-option>
                </mat-selection-list>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </div>
    <div style="display: flex; flex: 1; flex-direction: row">
      <div style="display: flex; flex-direction: column; width: 53%">
        <mat-card class="Card-style" style="height: 220px" data-cy="referral-portal-files-card">
          <mat-card-title-group>
            <mat-card-title class="Card-title" data-cy="referral-portal-files-title">Attach Files</mat-card-title>
          </mat-card-title-group>
          <mat-card-content>
            <div appDragFileToBrowser (files)="onFilesDropped($event)" class="dropzone" data-cy="referral-portal-files-dropzone">
              <div *ngFor="let item of documents; let i = index" class="image-container" [attr.data-cy]="'referral-portal-file-' + i">
                <img style="object-fit: contain; width: 50%;" alt="Document Type" [src]="getDocumentTypeFromUrl(documents[i])" data-cy="referral-portal-file-image"/>
                <label data-cy="referral-portal-file-description">{{documents[i].Description}}</label>
                <mat-icon (click)="DeleteFile(documents[i])" style="color: white" data-cy="referral-portal-file-delete">delete</mat-icon>
              </div>
              <div *ngIf="documents.length === 0"
                   style="width: fit-content; height: fit-content; margin-left: auto; margin-right: auto; transform: translateY(-50%); position: absolute; top: 50%; left: 50%">
                <mat-icon style="background: white" data-cy="referral-portal-files-empty">wallpaper</mat-icon>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
      <div style="display: flex; flex-direction: column; width: 47%">
        <mat-card class="Card-style" style="height: 220px" data-cy="referral-portal-notes-card">
          <mat-card-title-group>
            <mat-card-title class="Card-title" data-cy="referral-portal-notes-title">Notes</mat-card-title>
          </mat-card-title-group>
          <mat-card-content>
            <div style="display: flex; flex-direction: column;">
              <mat-form-field
                style="height: 130px" data-cy="referral-portal-notes-field">
                <textarea matInput [(ngModel)]="ReferralData.Notes" [attr.data-cy]="'Notes'" style="height: 106px" data-cy="referral-portal-notes-textarea"></textarea>
              </mat-form-field>
              <br/>
              <button mat-button class="tdo-button tdo-save" (click)="Submit()" style="margin-left: auto"
                      [disabled]="CheckIfSaveDisabled()"
                      [attr.data-cy]="'submitReferralPortalInformation'" data-cy="referral-portal-submit-button">Submit
              </button>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
</div>
<div *ngIf="!this.authorizedUser && !isLoading" data-cy="referral-portal-unauthorized">
  <h3>unauthorized access</h3>
</div>

